import Link from 'next/link';
import Moment from 'react-moment';
import styles from './booknow-footer.module.scss';

export default function BookNowFooter({ title, start_date, end_date, location, isDesktop, refBook = '#' }) {
  return (
    <>
      {isDesktop ? (
        <div className={styles.bookfooter}>
          <div>{title}</div>
          <div>
            <Moment format="MMM D" date={start_date}></Moment>
            {' - '}
            <Moment format="MMM D, Y" date={end_date}></Moment>
            <br />
            {location}
          </div>
          <div>
            <Link target={refBook?.includes('http') ? '_blank' : ''} href={refBook}>
              Book Now
            </Link>
          </div>
        </div>
      ) : (
        <div className={styles.bookfooter}>
          <div>
            {location} {title}
          </div>
          <div>
            <Link href={refBook}>Book Now</Link>
          </div>
        </div>
      )}
    </>
  );
}
